import { BiHomeAlt } from "react-icons/bi";
const api_url = `${process.env.REACT_APP_API_URL}`;
const SESSION_USER = "user";
const SESSION_TOKEN = "token";
const SESSION_EXPIRE = "expire";

const DOCUMENT = "C";
const PASSPORT = "PP";
const DOMINICAN = 1;
const WITHCREDENTIALS = 1;
const WITHGOOGLE = 2;

const authTitles = new Map()
  .set("/login/sign-up", "COMPLETAR REGISTRO")
  .set("/login", "INICIAR SESIÓN")
  .set("/login/sign-google", "COMPLETAR REGISTRO")
  .set("/verify", "VERIFICAR CORREO ELECTRÓNICO")
  .set("/change-password", "CAMBIAR CONTRASEÑA");

export {
  api_url,
  SESSION_EXPIRE,
  SESSION_TOKEN,
  SESSION_USER,
  authTitles,
  DOCUMENT,
  PASSPORT,
  DOMINICAN,
  WITHCREDENTIALS,
  WITHGOOGLE,
};

export const noAuthMenuVusa = [
  { icon: <BiHomeAlt></BiHomeAlt>, title: "Inicio", redirect: "/" },
];
